/**
 * De vijf menselijke stappen van een analyse zoals in het goedgekeurde
 * klikbare prototype (stepper bovenaan). Dit is de UI-indeling; de fijnmazige
 * {@link WorkflowStatus} van een run wordt hierop teruggebracht met
 * {@link stepIndexForStatus}.
 */
export const ANALYSIS_STEPS = [
    { key: 'invoer', label: 'Invoer' },
    { key: 'profiel', label: 'Bedrijfsprofiel' },
    { key: 'concurrenten', label: 'Concurrenten' },
    { key: 'verzamelen', label: 'Gegevens verzamelen' },
    { key: 'rapport', label: 'Rapport' },
];
/**
 * De stappen die los opnieuw uitgevoerd kunnen worden zónder de hele analyse
 * over te doen (US10-uitbreiding). De invoer- en rapportstap zijn afgeleid en
 * niet los herstartbaar.
 */
export const RESTARTABLE_STEPS = ['profiel', 'concurrenten', 'verzamelen'];
/**
 * Brengt een fijnmazige workflowstatus terug tot de index (0–4) van de
 * bijbehorende menselijke stap. Bepaalt welke stap in de stepper "actief"/
 * "bereikt" is en hoe ver de gebruiker terug/vooruit kan navigeren.
 *
 * Geannuleerd/mislukt tonen we op de verzamelstap: daar strandt een run
 * doorgaans en van daaruit kan hij per stap of volledig opnieuw.
 */
export function stepIndexForStatus(status) {
    switch (status) {
        case 'CREATED':
        case 'PROFILE_QUEUED':
        case 'PROFILE_RUNNING':
            return 0;
        case 'PROFILE_REVIEW_REQUIRED':
            return 1;
        case 'COMPETITOR_DISCOVERY_QUEUED':
        case 'COMPETITOR_DISCOVERY_RUNNING':
        case 'COMPETITOR_REVIEW_REQUIRED':
            return 2;
        case 'SOURCE_COLLECTION_QUEUED':
        case 'SOURCE_COLLECTION_RUNNING':
        case 'NORMALIZATION_RUNNING':
        case 'RELIABILITY_SCORING_RUNNING':
        case 'AI_SYNTHESIS_RUNNING':
        case 'REPORT_BUILD_RUNNING':
        case 'FAILED':
        case 'CANCELLED':
            return 3;
        case 'REVIEW_REQUIRED':
        case 'COMPLETED':
        case 'PARTIALLY_COMPLETED':
            return 4;
        default:
            return 0;
    }
}
//# sourceMappingURL=steps.js.map